module.exports = __webpack_public_path__ + "img/finance-application-nissan.c460206b.png";